"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _PageDetailsTitle = _interopRequireDefault(require("../TitlesAndTexts/PageDetailsTitle"));

var _ProductTitle = _interopRequireDefault(require("../TitlesAndTexts/ProductTitle"));

var _Button = _interopRequireDefault(require("../Buttons/Button"));

var _GoBackLink = _interopRequireDefault(require("../Navigation/GoBackLink"));

var _SmallText = _interopRequireDefault(require("../TitlesAndTexts/SmallText"));

var _PublishingServicesAvatar = _interopRequireDefault(require("../ImagesAndIcons/PublishingServicesAvatar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const MainWrapper = _styledComponents.default.div.withConfig({
  displayName: "FormLayout__MainWrapper",
  componentId: "design-system__sc-2lqf5x-0"
})(["display:grid;grid-template-columns:minmax(280px,1.5fr) minmax(300px,40rem) 2.5fr;grid-template-rows:16rem auto;grid-template-areas:'header header header' '. form . ';& > form{grid-area:form;}& > header{grid-area:header;display:grid;grid-template-rows:120px 144px;grid-template-columns:minmax(280px,1.5fr) minmax(300px,40rem) 2.5fr;grid-template-areas:'logo product-title' '. page-title';& > div.logo{grid-area:logo;justify-self:end;align-self:center;text-align:left;padding-right:0.5rem;& > svg{display:block;width:24px;height:28px;}}& > h4{grid-area:product-title;align-self:center;}& > div.page-title{grid-area:page-title;}}& > form > footer{padding:1.5rem 0 10rem;display:flex;align-items:center;& > button{margin-right:0.6rem;}& > a{padding-left:0.3rem;}}"]);

const FormLayout = _ref => {
  let {
    productTitle,
    children,
    submitLabel,
    onSubmit,
    disabled,
    onGoBack,
    pageTitle,
    previousLabel,
    onPrevious
  } = _ref,
      props = _objectWithoutProperties(_ref, ["productTitle", "children", "submitLabel", "onSubmit", "disabled", "onGoBack", "pageTitle", "previousLabel", "onPrevious"]);

  return /*#__PURE__*/_react.default.createElement(MainWrapper, null, /*#__PURE__*/_react.default.createElement("header", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "logo"
  }, /*#__PURE__*/_react.default.createElement(_PublishingServicesAvatar.default, null)), /*#__PURE__*/_react.default.createElement(_ProductTitle.default, null, productTitle), /*#__PURE__*/_react.default.createElement("div", {
    className: "page-title"
  }, /*#__PURE__*/_react.default.createElement(_GoBackLink.default, {
    onClick: onGoBack
  }, "Go back"), /*#__PURE__*/_react.default.createElement(_PageDetailsTitle.default, null, pageTitle || submitLabel))), /*#__PURE__*/_react.default.createElement("form", _extends({
    onSubmit: onSubmit
  }, props), /*#__PURE__*/_react.default.createElement("main", null, children), /*#__PURE__*/_react.default.createElement("footer", null, previousLabel && /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "outlined",
    submit: false,
    profile: "primary",
    onClick: onPrevious,
    "data-testid": "form-previous-button"
  }, previousLabel), /*#__PURE__*/_react.default.createElement(_Button.default, {
    submit: !disabled,
    type: "contained",
    profile: "primary",
    disabled: disabled,
    "data-testid": "form-submit-button"
  }, submitLabel), /*#__PURE__*/_react.default.createElement(_SmallText.default, null, "or"), /*#__PURE__*/_react.default.createElement(_GoBackLink.default, {
    onClick: onGoBack
  }, "Cancel"))), /*#__PURE__*/_react.default.createElement("link", {
    href: "https://fonts.googleapis.com/css2?family=Roboto+Condensed:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
    rel: "stylesheet"
  }));
};

FormLayout.propTypes = {
  productTitle: _propTypes.default.string.isRequired,
  children: _propTypes.default.node.isRequired,
  submitLabel: _propTypes.default.string.isRequired,
  pageTitle: _propTypes.default.string,
  onSubmit: _propTypes.default.func.isRequired,
  disabled: _propTypes.default.bool,
  onGoBack: _propTypes.default.func,
  previousLabel: _propTypes.default.string,
  onPrevious: _propTypes.default.func
};
FormLayout.defaultProps = {
  disabled: false,
  onGoBack: undefined,
  pageTitle: undefined,
  previousLabel: undefined,
  onPrevious: undefined
};
var _default = FormLayout;
exports.default = _default;